var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"robo-news"},[_c('OverviewSection'),_c('NewsIndex'),_c('NewsMain')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }